import React from 'react';
import { ModalCompletionFormIcon } from '../Elements/ModalCompletionFormIcon';

import './ModalButtonContent.css';

export const ModalButtonContent = ({ isConfirmed, loading, modalButtonIcon, modalButtonTitle }) => {
  return (
    <div className="badge-and-title-wrapper">
      <ModalCompletionFormIcon loading={loading} isConfirmed={isConfirmed} />
      <div className="badge-wrapper">{modalButtonIcon}</div>
      <div className="card-title">{modalButtonTitle}</div>
    </div>
  );
};
